import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import BaseLayout from '../../components/BaseLayout';
import ButtonPrimary from '../../components/Buttons/Button';
import { Heading } from '../../components/Heading';
import Paragraph from '../../components/Paragraph/Paragraph';
import { PAGES } from '../../constants/pages';

const ErrorPage = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <BaseLayout halfScreen noLogoBox>
      <Heading textAlign="center" fontWeight={700} mb={28}>
        {t('common.errorPageTitle')}
      </Heading>
      <Paragraph mb={28}>{t('common.errorPageText')}</Paragraph>
      <ButtonPrimary
        title={t('common.goBack')}
        onClick={() => history.push(PAGES.BASE)}
      />
    </BaseLayout>
  );
};

ErrorPage.propTypes = {};

export default ErrorPage;
